/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '../../ui-elements/image/image-cache.directive';
import * as import2 from '../../ui-elements/image/cached-image.service';
import * as import3 from '@angular/common';
import * as import4 from './store-map-panel.component';
const styles_StoreMapPanelComponent:any[] = ([] as any[]);
export const RenderType_StoreMapPanelComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_StoreMapPanelComponent,
  data: {}
}
);
function View_StoreMapPanelComponent_1(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'img',[[
        'class',
        'map-image'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(16384,(null as any),0,import1.ImageCacheDirective,[
      import0.ElementRef,
      import0.Renderer2,
      import2.CachedImageService
    ]
      ,{imageData: [
        0,
        'imageData'
      ]
    },(null as any))
  ]
  ,(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.store.locationImage;
    ck(v,1,0,currVal_0);
  },(null as any));
}
function View_StoreMapPanelComponent_2(l:any):import0.ɵViewDefinition {
      return import0.ɵvid(0,[(l()(),import0.ɵeld(0,(null as any),(null as any),0,'img',[[
        'class',
        'map-image'
      ]
      ],[[
        8,
        'src',
        4
      ]
  ],(null as any),(null as any),(null as any),(null as any)))],(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = co.mapImageSrc;
    ck(v,0,0,currVal_0);
  });
}
export function View_StoreMapPanelComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    import0.ɵqud(402653184,1,{map: 0}),
    (l()(),import0.ɵeld(0,[
      [
        1,
        0
      ]
      ,
      [
        'map',
        1
      ]

    ]
      ,(null as any),8,'div',[[
        'class',
        'map'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵdid(278528,(null as any),0,import3.NgClass,[
      import0.IterableDiffers,
      import0.KeyValueDiffers,
      import0.ElementRef,
      import0.Renderer
    ]
    ,{
      klass: [
        0,
        'klass'
      ]
      ,
      ngClass: [
        1,
        'ngClass'
      ]

    }
    ,(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreMapPanelComponent_1)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_StoreMapPanelComponent_2)),
    import0.ɵdid(16384,(null as any),0,import3.NgIf,[
      import0.ViewContainerRef,
      import0.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import4.StoreMapPanelComponent = v.component;
    const currVal_0:any = 'map';
    const currVal_1:any = (co.circleMap? 'circle': 'square');
    ck(v,2,0,currVal_0,currVal_1);
    const currVal_2:any = (co.store.locationImage.id || co.store.locationImage.image);
    ck(v,5,0,currVal_2);
    const currVal_3:boolean = (((!co.store.locationImage.id && !co.store.locationImage.image) && co.store.latitude) && co.store.longitude);
    ck(v,8,0,currVal_3);
  },(null as any));
}
function View_StoreMapPanelComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'woa-store-map-panel',([] as any[]),(null as any),(null as any),(null as any),View_StoreMapPanelComponent_0,RenderType_StoreMapPanelComponent)),
    import0.ɵdid(49152,(null as any),0,import4.StoreMapPanelComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const StoreMapPanelComponentNgFactory:import0.ComponentFactory<import4.StoreMapPanelComponent> = import0.ɵccf('woa-store-map-panel',import4.StoreMapPanelComponent,View_StoreMapPanelComponent_Host_0,{
  store: 'store',
  circleMap: 'circleMap'
}
,{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/app/store/store-map-panel/store-map-panel.component.ngfactory.ts